export const getInitialState = (): any => ({
  predictionData: {},
  predictionStatus: 0
});
